import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { CrewsTable } from '@sophocles/views/services/components';

function CrewsView(props) {
  const { t } = useTranslation();

  return (
    <AppNav page="services_crews" flex notFullHeight {...props}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', px: 2, pb: 1 }}>
        <TitleBar showBackButton title={t('projectServices.crews.pageTitle')} />
        <CrewsTable />
      </Box>
    </AppNav>
  );
}

export default CrewsView;
